// uses styleguide/customModal.less
import PropTypes from 'prop-types';

import React from 'react';
import Modal from './Modal';
import Loading from './Loading';

export const confirmPlacement = {
    sideNote: 'sideNote',
};

function CustomModal(props) {
    const buttons = props.buttons.map((button) => (
        <button
            key={button.key || button.label}
            type="button"
            className={button.className}
            onClick={button.handler}
            disabled={button.isDisabled}
        >
            {button.label}
        </button>
    ));

    let buttonWrapperClassName = 'sg-modal-buttons';
    if (props.buttonWrapperClassName)
        buttonWrapperClassName = `${props.buttonWrapperClassName} ${buttonWrapperClassName}`;

    return (
        <Modal
            className={props.className}
            closeHandler={props.closeHandler}
            hideCloseButton={props.hideCloseButton}
            closeBtnClassName={props.closeBtnClassName}
        >
            {typeof props.title === 'string' ? <h2 className="sg-modal-title">{props.title}</h2> : props.title}
            <Loading isLoaded={!props.isFetching} message={props.loadingMessage}>
                <div className={props.childrenWrapperClassName}>
                    {props.subTitle}
                    {props.confirmPlacement === confirmPlacement.sideNote && (
                        <div className={`${buttonWrapperClassName} ast-modal-buttons--centered`}>{buttons[1]}</div>
                    )}
                    {props.children}
                    {!props.confirmPlacement ? (
                        <div className={buttonWrapperClassName}>{buttons}</div>
                    ) : (
                        <div className={buttonWrapperClassName}>{buttons[0]}</div>
                    )}
                </div>
            </Loading>
        </Modal>
    );
}

CustomModal.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    subTitle: PropTypes.node,
    confirmPlacement: PropTypes.oneOf([confirmPlacement.sideNote]),
    children: PropTypes.node.isRequired,
    closeHandler: PropTypes.func.isRequired,
    isFetching: PropTypes.bool,
    isDisabled: PropTypes.bool,
    loadingMessage: PropTypes.string,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            className: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            handler: PropTypes.func.isRequired,
            isDisabled: PropTypes.bool,
            key: PropTypes.string,
        })
    ).isRequired,
    childrenWrapperClassName: PropTypes.string,
    buttonWrapperClassName: PropTypes.string,
    hideCloseButton: PropTypes.bool,
    closeBtnClassName: PropTypes.string,
};

export default CustomModal;
